import { memo } from 'react'
import './PatientEditInfoCard.scss'

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
export const PatientEditInfoCard = memo(({ title, children, isTooltipOutside, className = '', style = {} }) => (
  <div
    className={`patient-edit-info-card-main-wrapper${
      isTooltipOutside ? 'patient-edit-info-card-main-wrapper--tooltip-outside' : ''
    }${className ? ` ${className}` : ''}`}
    style={style}>
    <div className='patient-edit-info-card-title'>{title}</div>
    {children}
  </div>
))
